import { useEffect } from 'react';
import { BrowserNotificationServiceInstance } from '@/shared/services/browser-notification.service';

// Chrome silently suppresses (or shows only a muted address-bar chip for)
// Notification.requestPermission() calls that aren't tied to a real user
// gesture — so we wait for the user's first click/keypress after load
// rather than requesting on mount.
export function useNotificationPermissionHandler() {
  useEffect(() => {
    if (
      typeof Notification === 'undefined' ||
      typeof Notification.requestPermission !== 'function' ||
      Notification.permission !== 'default'
    ) {
      return;
    }

    const requestOnce = () => {
      document.removeEventListener('click', requestOnce);
      document.removeEventListener('keydown', requestOnce);
      void BrowserNotificationServiceInstance.requestPermission();
    };

    document.addEventListener('click', requestOnce, { once: true });
    document.addEventListener('keydown', requestOnce, { once: true });

    return () => {
      document.removeEventListener('click', requestOnce);
      document.removeEventListener('keydown', requestOnce);
    };
  }, []);
}
